import { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useSnackbar } from 'baseui/snackbar'
import { useTranslation } from 'react-i18next'

import { selectAuthData } from '@/containers/Login/AuthSelectors'
import { AVAILABLE_COMMUNICATION_BOARD_SECTIONS } from '@/containers/SubscriptionFormPageNew/Components/CommunicationBoard/constants'

import { selectCommunicationBoardStoreData } from './communicationBoardSelectors'
import { setSection, setContent, reset } from './communicationBoardSlice'
import { communicationBoardActions } from './communicationBoardSagas'

const useCommunicationBoard = () => {
  const dispatch = useDispatch()
  const { enqueue } = useSnackbar()
  const { t } = useTranslation('devToolsNew')
  const { tinymceKey } = useSelector(selectAuthData)

  const { section, content, isLoading, isSaving, resultError, resultMessage } = useSelector(
    selectCommunicationBoardStoreData,
  )

  useEffect(() => {
    dispatch(reset())
  }, [])

  useEffect(() => {
    dispatch({
      type: communicationBoardActions.FETCH,
      enqueue,
      t,
      payload: { section },
    })
  }, [section])

  const sectionsOptions = AVAILABLE_COMMUNICATION_BOARD_SECTIONS.reduce((acc, sectionKey) => {
    acc[sectionKey] = t(`communication_board.sections.${sectionKey}`)
    return acc
  }, {})

  const onSectionChange = id => dispatch(setSection(id ?? AVAILABLE_COMMUNICATION_BOARD_SECTIONS[0]))
  const onContentChange = value => dispatch(setContent(value))

  const onSave = () => {
    dispatch({
      type: communicationBoardActions.SAVE,
      enqueue,
      t,
      payload: { section },
    })
  }

  return {
    form: {
      tinymceKey,
      sectionsOptions,
      section,
      content,
      isLoading,
      isSaving,
      onSectionChange,
      onContentChange,
      onSave,
    },
    result: {
      error: resultError,
      message: resultMessage,
    },
    t,
  }
}

export default useCommunicationBoard
